module.exports = __webpack_public_path__ + "img/abdf9f3.png";